import type { SubOrder } from "@/api/api-client"
import { OrderFinancialSummary } from "@/components/orders/OrderFinancialSummary"

import type { VendorOrderLabels } from "./vendor-order-types"

interface VendorOrderFinancialsProps {
  subOrder: Pick<SubOrder, "items" | "subTotal" | "taxAmount" | "shippingCost" | "totalAmount">
  labels: Pick<VendorOrderLabels, "total" | "productCost" | "tax" | "shippingCost" | "totalAmount">
}

function getVendorOrderFinancials(subOrder: VendorOrderFinancialsProps["subOrder"]) {
  const itemSubtotal =
    subOrder.items?.reduce((sum, item) => sum + (item.price || 0) * (item.quantity || 0), 0) || 0
  const productSubtotal = subOrder.subTotal ?? itemSubtotal
  const taxAmount = subOrder.taxAmount ?? 0
  const shippingCost = subOrder.shippingCost ?? 0
  const totalPrice = subOrder.totalAmount ?? productSubtotal + taxAmount + shippingCost

  return { productSubtotal, taxAmount, shippingCost, totalPrice }
}

export function VendorOrderFinancials({ subOrder, labels }: VendorOrderFinancialsProps) {
  const { productSubtotal, taxAmount, shippingCost, totalPrice } =
    getVendorOrderFinancials(subOrder)

  return (
    <OrderFinancialSummary
      title={labels.total || "TOTAL AMOUNT"}
      totalAmount={totalPrice}
      rows={[
        { label: labels.productCost || "Products", amount: productSubtotal },
        { label: labels.tax || "Tax", amount: taxAmount },
        { label: labels.shippingCost || "Shipping", amount: shippingCost },
        { label: labels.totalAmount || "Total", amount: totalPrice, highlight: true },
      ]}
    />
  )
}
